require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/is-iterable.js
// module id = 263
// module chunks = 0 1


// WEBPACK FOOTER //
// webpack:///node_modules/core-js/library/fn/is-iterable.js